import landingconfigure from "../assets/media/images/home/Landing-configure.png";
import landingprocess from "../assets/media/images/home/Landing-processing.png";
import landingdata from "../assets/media/images/home/Landing-data.png";
import landing1st from "../assets/media/images/home/Landing1st.png";
import { MainRoutes } from "../common/config";
// import { ChartOptions, ChartData } from "chart.js";

// import {
//   Cog6ToothIcon,
//   HomeIcon,
//   UserIcon,
//   FolderIcon,
// } from '@heroicons/react/24/outline';

import {
  PiSlidersHorizontalBold,
  PiDatabaseBold,
  PiChartBarBold,
  PiFolderSimpleMinus
} from "react-icons/pi";

// import { IconType } from "react-icons";

// export interface SidebarLink {
//   icon: IconType;
//   route: string;
//   label: string;
// }

// export const sidebarLinks: SidebarLink[] = [
//   { icon: HomeIcon, route: '/', label: 'Home' },
//   { icon: Cog6ToothIcon, route: '/c', label: 'Settings' },
//   { icon: UserIcon, route: '/users', label: 'Users' },
//   { icon: FolderIcon, route: '/files', label: 'Documents' },
//   { icon: PiSlidersHorizontalBold, route: '/configure-ops', label: 'Configuration Hub' },
//   { icon: PiDatabaseBold, route: '/processing-hub', label: 'Processing Hub' },
//   { icon: PiChartBarBold, route: '/analysis', label: 'Analysis Hub' },
//   { icon: PiFolderSimpleMinus, route: '/similarity', label: 'Similarity Hub' },
// ];

export interface FeatureCard {
  image: string;
  title: string;
  description: string;
  icon?: typeof PiChartBarBold;
  route?: string;
  rounded?: boolean;
}

export const featureCards: FeatureCard[] = [
  {
    image: landingconfigure,
    title: "Configuration Hub",
    description:
      "Centralized system or interface used to setup document configuration",
    icon: PiSlidersHorizontalBold,
    route: "/configure",
    rounded: true
  },
  {
    image: landingprocess,
    title: "Processing Hub",
    description:
      "Handles the automated tasks that upload and process document configuration",
    icon: PiDatabaseBold,
    route: "/processing-hub"
  },
  {
    image: landingdata,
    title: "Data Analysis Hub",
    description:
      "Transforms raw data to analyze, aggregate and validate extracted data",
    icon: PiChartBarBold,
    route: "/analysis"
  }
];

export const featureCardData = {
  title: "Application Features Hub",
  subtitle: "Features available within the data transformation application"
};

export const heroSection = {
  title: "O&G Unstructured Data Transformation Platform",
  subtitle:
    "An integrated platform for transforming unstructured documents into actionable data through effective management, analysis, and utilization.",
  image: landing1st
};

export const ConfigureOpsData = {
  title: "Configuration Hub",
  description:
    "Define the extraction, mappings, and flow for seamless processing",
  action: "View"
};

export const ConfigureOpsOptions = [
  // { value: "Operations", label: "Operations" },
  // { value: "Procurement", label: "Procurement" },
  // { value: "Finance", label: "Finance" },
  // { value: "Capital_projects", label: "Capital Projects" },
  { value: "Engineering", label: "Engineering" },
  { value: "Finance", label: "Finance" },
  { value: "HR", label: "HR" }
];

export const tagCategories = [
  { value: "equipment_class", label: "Equipment Class" },
  { value: "asset_class", label: "Asset Class" },
  { value: "instrument_class", label: "Instrument Class" },
  { value: "machinery_class", label: "Machinery Class" },
  { value: "fixed_class", label: "Fixed Class" }
];

export const requirementTypes = [
  { value: "functional_requirement", label: "Functional Requirement" },
  { value: "technical_requirement", label: "Technical Requirement" },
  { value: "specifications", label: "Specifications" }
];

export interface Step {
  id: number;
  title: string;
  description: string;
}

export const steps: Step[] = [
  {
    id: 1,
    title: "Attributes Extraction",
    description:
      "Identifying and extraction specific pieces of important information (called attributes) from a data source."
  },
  {
    id: 2,
    title: "Document Tagging",
    description:
      "Adding labels or keywords (called tags) to a document to describe its content"
  },
  {
    id: 3,
    title: "Similarity Search",
    description: "Similarity Search"
  },
  {
    id: 4,
    title: "Export",
    description: "Export extracted data in different available formats"
  }
];

export const configureDocTitle = "Configuration Hub";
export const configureDocDescription =
  "Define the extraction, mappings, and flow for seamless processing";

export const docOptions = [
  {
    title: "Extraction Configuration",
    description:
      "Configure fields and extraction settings for various document types",
    route: null,
    iconType: "upload"
  },
  {
    title: "Tag Library Configuration",
    description:
      "Manage tag libraries with AI-powered enrichment and embeddings",
    route: MainRoutes.TAG_LIBRARY_CONFIG,
    iconType: "tag"
  },
  {
    title: "Flow Configuration",
    description: "Configure document processing flow and automation settings",
    route: MainRoutes.ASSIGNMENT,
    iconType: "plus"
  }
];

export const ProcessHubStep1 = {
  label: "Document Type",
  requiredNote: "*",
  placeholder: "Select document type",
  options: [
    { value: "", label: "Select document type", disabled: true },
    { value: "Inspection Document", label: "Inspection Document" },
    { value: "Design Documents", label: "Design Documents" }
  ],
  descriptions: {
    "Inspection Document":
      "Provides structured information about the condition, compliance, or performance of a product",
    "Design Documents": "Design-related engineering documents"
  },
  descriptionLabel: "Document Description",
  uploadLabel: "Click to upload the documents",
  uploadButtonText: "Upload"
};

export const ProcessHubStep2 = {
  heading: "Document Tagging",
  subheading:
    "Adding labels or keywords (called tags) to a document to describe its content",
  tableHeaders: ["Tag Category", "Description", "Tags"],
  tagCategories: [
    {
      category: "Equipment Class",
      description:
        "Category or grouping used to classify equipment based on certain characteristics"
    },
    {
      category: "Asset Class",
      description:
        "Isolated area with mechanical damage across 35% of the gasket seating surface."
    },
    {
      category: "Instrument Class",
      description:
        "Isolated area with mechanical damage across 35% of the gasket seating surface."
    },
    {
      category: "Machinery Class",
      description:
        "Isolated area with mechanical damage across 35% of the gasket seating surface."
    },
    {
      category: "Fixed Class",
      description:
        "Isolated area with mechanical damage across 35% of the gasket seating surface."
    },
    {
      category: "Instrument Class",
      description: "Carbon Steel with a 317SS WOL"
    }
  ]
};

export const ProcessHubStep3 = {
  heading: "Attributes Extraction",
  subheading:
    "Identifying and extraction specific pieces of attributes from a data source.",
  tableHeaders: ["Attribute Name", "Attribute Instruction", "Validation"],
  attributes: [
    ["Functional Requirement", "Particular inputs captured"],
    ["Technical Requirement", "Available spare parts to be visible"],
    ["Specifications", "Range more than 20% adapted"],
    [
      "Machinery Requirement",
      "Mechanical damage across 35% of the gasket seating surface."
    ],
    ["Fixed Requirement", "Area should be measured"],
    ["Instrument Requirement", "Carbon Steel with a 317SS WOL"]
  ]
};

export const ProcessHubStep4 = {
  heading: "Review and Validation",
  subheading: "Information or data is validated before moving forward",
  viewToggle: {
    view: "View Summary",
    hide: "Hide Summary"
  },
  batchLabel: "Batch",
  batchOptions: ["Batch 1", "Batch 2", "Batch 3"],
  tableHeaders: [
    "File Name",
    "Type",
    "Updated On",
    "Tags",
    "Extraction",
    "Action"
  ],
  tableRows: [
    ["Features Document", "PDF", "02/05/2025", "Equipment Class"],
    ["Specification Document", "Docx", "03/05/2025", "Asset Class"],
    ["Manway", "PDF", "04/05/2025", "Technical Document"],
    ["Tunnel Document", "DOCX", "05/05/2025", "Asset Class"],
    ["Capacity Feature", "IMG", "06/05/2025", "Technical Discipline"],
    ["Turnaround Document", "DOCX", "06/05/2025", "Technical Document"]
  ]
};

export const ProcessHubStep5 = {
  title: "Export",
  subtitle: "Exporting extracted data in different available formats",
  exportButtonLabel: "Export",
  tableHeaders: [
    "File Name",
    "Type",
    "Updated On",
    "Tags",
    "Extraction",
    "Validation",
    "Action"
  ],
  tableRows: [
    {
      name: "Features Document",
      type: "PDF",
      date: "02/05/2025",
      tag: "Equipment Class"
    },
    {
      name: "Specification Document",
      type: "Docx",
      date: "03/05/2025",
      tag: "Asset Class"
    },
    {
      name: "Manway",
      type: "PDF",
      date: "04/05/2025",
      tag: "Technical Document"
    },
    {
      name: "Tunnel Document",
      type: "DOCX",
      date: "05/05/2025",
      tag: "Asset Class"
    },
    {
      name: "Capacity Feature",
      type: "IMG",
      date: "06/05/2025",
      tag: "Technical Discipline"
    },
    {
      name: "Turnaround Document",
      type: "DOCX",
      date: "06/05/2025",
      tag: "Technical Document"
    }
  ]
};

// export const ATTRIBUTE_BAR_CHART = {
//   labels: ["q1", "q2", "q3", "q4"],
//   datasets: [
//     {
//       label: "Date",
//       backgroundColor: "#6366F1",
//       data: [20, 30, 25, 22]
//     },
//     {
//       label: "Value",
//       backgroundColor: "#EC4899",
//       data: [25, 35, 30, 28]
//     },
//     {
//       label: "Text",
//       backgroundColor: "#A78BFA",
//       data: [30, 40, 45, 50]
//     }
//   ]
// };

// export const BAR_CHART_OPTIONS: ChartOptions<"bar"> = {
//   responsive: true,
//   plugins: {
//     legend: {
//       position: "bottom"
//     }
//   }
// };

// export const TAGS_DOUGHNUT_CHART_DATA: ChartData<"doughnut"> = {
//   labels: ["Asset Class", "Technical Equipment", "Technical Document"],
//   datasets: [
//     {
//       label: "Tag %",
//       data: [50, 15, 35],
//       backgroundColor: ["#6366F1", "#EC4899", "#A78BFA"],
//       borderWidth: 1
//     }
//   ]
// };

// export const DOUGHNUT_CHART_OPTIONS: ChartOptions<"doughnut"> = {
//   maintainAspectRatio: false,
//   plugins: {
//     legend: {
//       position: "bottom" // strictly typed
//     }
//   }
// };
